import TableRegistros from "../../Components/Tables/TableRegistros";
import TopBar from "../../Layout/TopBar/TopBar";

const Registros = () => {

    return (
        <div style={{display:"flex", flexDirection:"column"}}>
            <TopBar />
            <TableRegistros />
        </div>
    );
}
export default Registros;